import React from "react";
import { useCandidateLayout } from "../../Components/Context/CandidateLayoutContext";
import {
  Box,
  Button,
  Divider,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CircleIcon from "@mui/icons-material/Circle";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import FeedIcon from "@mui/icons-material/Feed";

import { useNavigate } from "react-router-dom";
import CommonButton from "../../Components/InputComponents/CommonButton";

function CandidateJobs() {
  const { candidateData, candidateJobData } = useCandidateLayout();

  const Navigate = useNavigate();

  return (
    <Box
      sx={{
        p: 4,
        mx: "auto",
        margin: "auto",
        padding: "20px",
        maxWidth: `100vw`,
      }}
    >
      <CommonButton
        background="#006CB8"
        textColor="white"
        onClick={() => Navigate(`/`)}
        sx={{
          minWidth: "100px",
          color: "white",
          mt: 0.5,
          borderRadius: "20px",
          height: "30px",
          textTransform: "capitalize",
        }}
      >
        Back
      </CommonButton>
      <Typography
        sx={{
          fontFamily: "Geist, sans-serif",
          fontSize: { xs: "16px", sm: "18px", lg: "22px" },
          fontWeight: 700,
          margin: "10px auto",
        }}
      >
        Jobs
      </Typography>
      {/* Job Procedure Mapping */}
      <Grid container>
        {candidateJobData?.map((job, index) => {
          const jobTitle = job?.JD_Title;
          const jobId = job?.JD_JobId;
          const stages = job?.recruitment_json
            ? JSON.parse(job.recruitment_json)?.stages || []
            : [];

          return (
            <Grid
              item
              xs={12}
              key={index}
              sx={{
                border: "1px solid lightgrey",
                margin: "10px auto",
                borderRadius: "10px",
                padding: "15px",
              }}
            >
              {/* Application Progress - Job Title */}
              <Typography
                sx={{
                  px: 2,
                  textAlign: "left",
                  fontFamily: "Geist, sans-serif",
                  letterSpacing: `0.5px`,
                  fontSize: "22px",
                  color: "#333",
                  fontWeight: "600",
                }}
              >
                ({jobId}) - {jobTitle}
              </Typography>

              {/* Horizontal Scrollable Box of Stages */}
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "nowrap",
                  overflowX: "auto",
                }}
              >
                {stages?.map((stage, stageIndex) => {
                  const hasSubProcedures =
                    stage?.subProcedures && stage.subProcedures.length > 0;

                  const subComponents = hasSubProcedures
                    ? stage.subProcedures.map((sub) => {
                        const field = sub.fields?.find(
                          (f) => f?.RPF_Type === "IsCompleted"
                        );

                        const rawValue = Array.isArray(field?.RPF_Value)
                          ? field?.RPF_Value[0]
                          : field?.RPF_Value;
                        const isCompleted = rawValue;

                        return { ...sub, isCompleted };
                      })
                    : [];

                  let stageStatus = 0;
                  let stageStatusField = null;

                  if (!hasSubProcedures) {
                    stageStatusField = stage.fields?.find(
                      (field) => field?.RPF_Type === "IsCompleted"
                    );
                    const rawValue = Array.isArray(stageStatusField?.RPF_Value)
                      ? stageStatusField?.RPF_Value[0]
                      : stageStatusField?.RPF_Value;
                    stageStatus = parseInt(rawValue || "0");
                  } else {
                    const subCompletionFlags = subComponents.map((sub) =>
                      sub.isCompleted == 1 ? 1 : 0
                    );

                    const allCompleted = subCompletionFlags.every(
                      (v) => v === 1
                    );
                    stageStatus = allCompleted ? 1 : 0;
                  }

                  const getColorStyles = (status) => {
                    switch (status) {
                      case 1:
                        return { border: "#22C55E", background: "#22C55E1A" };
                      case 2:
                        return { border: "#9CA3AF", background: "#F3F4F6" };
                      case 3:
                        return { border: "#3B82F6", background: "#3B82F61A" };
                      default:
                        return { border: "#3B82F6", background: "#3B82F61A" };
                    }
                  };

                  const { border: stageBorderColor, background: stageBgColor } = getColorStyles(stageStatus);

                  const fieldsOnly = stage?.fields || [];
                  const subProcedureFields = ( stage?.subProcedures || [] ).flatMap((sub) => sub?.fields || []);

                  const stageStatusFieldMain = fieldsOnly.find((field) =>field?.RPF_Name?.trim()?.toLowerCase().includes("status"));

                  const stageStatusSubField = subProcedureFields.find((field) => field?.RPF_Name?.trim()?.toLowerCase().includes("status"));

                  // Color code for sidebar
                  const getStageColor = (status) => {
                    switch (status) {
                      case "1":
                        return {
                          border: "#22C55E", //Green
                          bg: "#22C55E0D",
                          label: "Completed",
                        };
                      case "2":
                        return {
                          border: "#9CA3AF", // Greyish (Tailwind's gray-400)
                          bg: "#9CA3AF0D",
                          label: "Draft",
                        };
                      default:
                        return {
                          border: "#006CB8", // Blue
                          bg: "#EBF2FF",
                          label: "In Progress",
                        };
                    }
                  };
                  
                  // 0 = in progress
                  // 1 = completed
                  // 2 = Draft

                   function getExpiryStatus(field) {
                    if (field.RPF_Type !== "Date") return null;

                    // 🔹 Check if expiry is enabled
                    if (field.RPF_IsExpiry == undefined) {
                      return null;
                    }

                    // 1. Parse expiry period
                    let expiryDays = 0;
                    if (
                      field.RPF_ExpiryPeriod &&
                      field.RPF_IsExpiry != undefined
                    ) {
                      try {
                        expiryDays = Number(
                          field.RPF_ExpiryPeriod.toString().replace(/"/g, "")
                        );
                      } catch {
                        expiryDays = 0;
                      }
                    }

                    // 2. Parse the base date (RPF_Value)
                    if (!field.RPF_Value) return null;
                    const baseDate = new Date(field.RPF_Value);
                    if (isNaN(baseDate)) return null;

                    // 3. Calculate expiry date
                    const expiryDate = new Date(baseDate);
                    expiryDate.setDate(baseDate.getDate() + expiryDays);

                    // 4. Compare with today
                    const today = new Date();
                    const diffTime = expiryDate - today;
                    const diffDays = Math.ceil(
                      diffTime / (1000 * 60 * 60 * 24)
                    );

                    // Helper for singular/plural
                    const dayLabel = (n) =>
                      Math.abs(n) === 1 ? "day" : "days";

                    // 5. Handle result
                    if (diffDays > 30) {
                      return null; // don’t show if more than 30 days left
                    } else if (diffDays > 0) {
                      return {
                        value: `${field.RPF_Name}: ${diffDays} ${dayLabel(
                          diffDays
                        )} pending`,
                        fontSize: "16px",
                        color: "black",
                      };
                    } else if (diffDays === 0) {
                      return {
                        value: `${field.RPF_Name}: Expires today`,
                        fontSize: "16px",
                        color: "black",
                      };
                    } else if (diffDays >= -60) {
                      return {
                        value: `${field.RPF_Name}: Expired ${Math.abs(
                          diffDays
                        )} ${dayLabel(diffDays)} ago`,
                        fontSize: "16px",
                        color: "red",
                      };
                    } else {
                      return null; // don’t show if expired more than 60 days ago
                    }
                  }

                  return (
                    <Box
                      key={stageIndex}
                      sx={{
                        minWidth: "300px",
                        // minHeight: "250px",
                        border: `2px solid ${stageBorderColor}`,
                        backgroundColor: stageBgColor,
                        borderRadius: 2,
                        m: 2,
                        p: 2,
                        boxShadow: "0px 2px 6px rgba(0,0,0,0.08)",
                        display: hasSubProcedures ? "block" : "flex",
                        flexDirection: hasSubProcedures ? "initial" : "column",
                        alignItems: `center`,
                        alignContent: `center`,
                        justifyContent: `center`,
                        textAlign: `center`,
                      }}
                    >
                      {/* Main Stage */}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          alignContent: "center",
                          justifyContent: `center`,
                          position: "relative",
                          top: "18px",
                        }}
                      >
                        {stageStatus === 1 ? (
                          <CheckCircleIcon
                            sx={{ color: "#22C55E", fontSize: 25, mx: 1 }}
                          />
                        ) : stageStatus === 2 ? (
                          <FeedIcon
                            sx={{ color: "#9CA3AF", fontSize: 24, mx: 1 }}
                          />
                        ) : (
                          <AccessTimeIcon
                            sx={{ color: "#3B82F6", fontSize: 25, mx: 1 }}
                          />
                        )}
                        <Typography
                          fontWeight={600}
                          fontSize={16}
                          sx={{
                            textTransform: "capitalize",
                            fontFamily: "Geist, sans-serif",
                          }}
                        >
                          {stage?.RPS_Name || "Unnamed Stage"}
                        </Typography>
                        
                        {/* New Implementation - 09-09-25 - Expiry Date */}

                        {stage?.fields?.map((field) => {
                          const status = getExpiryStatus(field);
                          return (
                            <Box key={field.RPF_Id}>
                              {status?.value && (
                                <Typography
                                  sx={{
                                    fontSize: status?.fontSize,
                                    color: status?.color,
                                    textTransform: "Capitalize",
                                    textAlign:'left'
                                  }}
                                >
                                  {status?.value}
                                </Typography>
                              )}
                            </Box>
                          );
                        })}
                      </Box>

                      <Divider sx={{ my: 2.5 }} />

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          alignContent: "center",
                          justifyContent: "center",
                          gap: 1,
                        }}
                      >
                        <Typography
                          fontWeight={600}
                          sx={{
                            textTransform: "capitalize",
                            fontFamily: "Geist, sans-serif",
                            fontSize: "14",
                          }}
                        >
                          {stageStatusFieldMain?.RPF_Name &&
                          stageStatusFieldMain?.RPF_Value
                            ? `${stageStatusFieldMain?.RPF_Name} : ${stageStatusFieldMain?.RPF_Value}`
                            : null}
                        </Typography>
                      </Box>

                      {/* SubTabs (if any) */}
                      {hasSubProcedures &&
                        subComponents.map((sub, subIndex) => {
                          const subStatus = sub.isCompleted;

                          const subColor = getStageColor(subStatus);

                          const stageStatusSubFieldPosition = (
                            sub?.fields || []
                          ).find(
                            (field) =>
                              field?.RPF_Id == stageStatusSubField?.RPF_Id
                          );
                          return (
                            <Box
                              sx={{
                                px: 1.5,
                                borderLeft: `4px solid ${
                                  sub.isCompleted == 1
                                    ? "#22C55E"
                                    : sub.isCompleted == 2
                                    ? "#9CA3AF"
                                    : "#3B82F6"
                                }`,
                                backgroundColor:
                                  sub.isCompleted == 1
                                    ? "#22C55E1A"
                                    : sub.isCompleted == 2
                                    ? "#F3F4F6"
                                    : "#3B82F61A",
                                p: 1,
                              }}
                            >
                              <Box
                                key={subIndex}
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  borderRadius: 1,
                                }}
                              >
                                {sub.isCompleted == 1 ? (
                                  <CheckCircleIcon
                                    sx={{
                                      color: "#22C55E",
                                      fontSize: 25,
                                      mx: 1,
                                      mt: 0.5,
                                    }}
                                  />
                                ) : sub.isCompleted == 2 ? (
                                  <FeedIcon
                                    sx={{
                                      color: "#9CA3AF",
                                      fontSize: 24,
                                      mx: 1,
                                      mt: 0.5,
                                    }}
                                  />
                                ) : (
                                  <AccessTimeIcon
                                    sx={{
                                      color: "#3B82F6",
                                      fontSize: 25,
                                      mx: 1,
                                      mt: 0.5,
                                    }}
                                  />
                                )}
                                <Typography
                                  fontSize={14}
                                  fontWeight={500}
                                  sx={{
                                    textTransform: "capitalize",
                                    fontFamily: "Geist, sans-serif",
                                    fontSize: "14",
                                    marginTop: "5px",
                                  }}
                                >
                                  {sub?.RSP_Name || "Unnamed Sub"}
                                </Typography>
                              </Box>

                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "flex-start",
                                  alignContent: "center",
                                  justifyContent: "center",
                                  gap: 1,
                                  mb: 1,
                                }}
                              >
                                <Typography
                                  fontWeight={600}
                                  fontSize={14}
                                  sx={{
                                    textTransform: "capitalize",
                                    fontFamily: "Geist, sans-serif",
                                  }}
                                >
                                  {stageStatusSubField?.RPF_Name &&
                                  stageStatusSubField?.RPF_Value
                                    ? `${stageStatusSubField?.RPF_Name} : ${stageStatusSubField?.RPF_Value}`
                                    : null}
                                </Typography>

                                {stageStatusSubFieldPosition && (
                                  <Typography
                                    sx={{ color: subColor.border }}
                                    fontSize="14"
                                  >
                                    {stageStatusSubFieldPosition.RPF_Value
                                      ? `${stageStatusSubFieldPosition?.RPF_Name} : `
                                      : ""}
                                    {Array.isArray(
                                      stageStatusSubFieldPosition.RPF_Value
                                    )
                                      ? stageStatusSubFieldPosition.RPF_Value.join(
                                          ", "
                                        )
                                      : stageStatusSubFieldPosition.RPF_Value ||
                                        ""}
                                  </Typography>
                                )}
                                

                                {/* New Implementation - 09-09-25 - Expiry Date */}

                                {sub?.fields?.map((field) => {
                                  const status = getExpiryStatus(field);
                                  return (
                                    <Box key={field.RPF_Id}>
                                      {status && (
                                        <Typography
                                          sx={{
                                            fontSize: status?.fontSize,
                                            color: status?.color,
                                            textTransform: "Capitalize",
                                          }}
                                        >
                                          {status?.value}
                                          
                                        </Typography>
                                      )}
                                    </Box>
                                  );
                                })}
                              </Box>
                            </Box>
                          );
                        })}
                    </Box>
                  );
                })}
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}

export default CandidateJobs;
